import { createStore, applyMiddleware } from "redux";
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';


import rootReducer from "./reducers";

const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk)));
export default store;

let currentValue;
store.subscribe(() => {
    let previousValue = currentValue
    currentValue = (store.getState().cart.items);
    if (previousValue !== currentValue) {
        const cartItemsString = JSON.stringify(store.getState().cart.items);
        localStorage.setItem("cart", cartItemsString);
    }
});


